import styled, { css } from 'styled-components'
import InputOriginal from '../input-original'


export const InputStyled = styled(InputOriginal)<{ error?: string }>`
  
`